import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Attachment = _resolveComponent("Attachment")!
  const _component_NodeViewWrapper = _resolveComponent("NodeViewWrapper")!

  return (_openBlock(), _createBlock(_component_NodeViewWrapper, {
    as: "div",
    draggable: "false",
    onClick: _ctx.onSelectNode
  }, {
    default: _withCtx(() => [
      (!_ctx.isBase64)
        ? (_openBlock(), _createBlock(_component_Attachment, {
            key: 0,
            node: _ctx.node,
            editor: _ctx.editor,
            updateAttributes: _ctx.updateAttributes,
            getPos: _ctx.getPos
          }, null, 8, ["node", "editor", "updateAttributes", "getPos"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClick"]))
}